import { Gamepad2 } from 'lucide-react'
import { games } from '@/data/games'
import GameCard from './GameCard'
import ComingSoonCard from './ComingSoonCard'
import { useLanguage } from '@/localization'

/**
 * Data-driven, scalable game grid. Pulls entries from `src/data/games.ts` —
 * adding a new game later is a single array entry. Live and featured upcoming
 * games render as large photo cards; other upcoming games render in the compact
 * "On the horizon" row.
 */
export default function GameGrid() {
  const { t } = useLanguage()
  const featured = games.filter((g) => g.status === 'live' || g.featured)
  const soon = games.filter((g) => g.status === 'soon' && !g.featured)

  return (
    <section
      id="games"
      className="relative scroll-mt-20 px-6 py-20"
    >
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-stone-line bg-white px-4 py-1.5 font-rajdhani text-xs font-semibold uppercase tracking-[0.25em] text-uliunai-red shadow-card">
            <Gamepad2 size={18} />
            {t('Our games')}
          </span>
          <h2 className="metal-text mt-5 font-orbitron text-4xl font-black tracking-tight sm:text-5xl">
            {t('Choose Your World')}
          </h2>
          <div className="mt-4 flex items-center justify-center gap-3">
            <span className="h-[2px] w-10 bg-gradient-to-r from-transparent to-uliunai-red" />
            <span className="h-1.5 w-1.5 rotate-45 bg-uliunai-red" />
            <span className="h-[2px] w-10 bg-gradient-to-l from-transparent to-uliunai-red" />
          </div>
          <p className="mx-auto mt-4 max-w-xl font-rajdhani text-base text-stone-600">
            {t('Jump into any of our community servers. Each game has its own home - pick one and play.')}
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-6 md:grid-cols-2">
          {featured.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>

        {soon.length > 0 && (
          <div className="mt-16">
            <div className="text-center">
              <h3 className="font-orbitron text-2xl font-bold text-stone-800">
                {t('On the Horizon')}
              </h3>
              <p className="mx-auto mt-2 max-w-xl font-rajdhani text-sm text-stone-500">
                {t('More worlds joining the Uliunai community soon.')}
              </p>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
              {soon.map((game) => (
                <ComingSoonCard key={game.id} game={game} />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
